<template>
  <NuxtLayout>
    <template #error>
      <SFErrorLayout :error="error || null" @clear-error="resetErrorState" />
    </template>
  </NuxtLayout>
</template>

<script setup lang="ts">
import SFErrorLayout from './components/layout/SFErrorLayout.vue'
import { NuxtLayout } from '#components'
import { clearError, useError } from '#app/composables/error'
import { routeList } from '~/./utils/route'
import { useCurrentShop } from '#storefront/composables'
import { useLocalePath } from '#i18n'

const error = useError()
const currentShop = useCurrentShop()
const localePath = useLocalePath()

const resetErrorState = async () => {
  const redirect = localePath(routeList.home).toString()
  if (currentShop.value) {
    await clearError({ redirect })
  }

  window.location.href = redirect
}

defineOptions({ name: 'GlobalError' })
</script>
